import type { Renderer } from './base/Renderer';
import { TopDownRenderer } from './canvas2d/TopDownRenderer';
import { VoxelWebGLRenderer } from './webgl/VoxelWebGLRenderer';
import { ThreeJSRenderer } from './webgl/ThreeJSRenderer';
import type { RendererType } from '../core/types/SimulationTypes';

export class RendererFactory {
  public static create(type: RendererType): Renderer {
    switch (type) {
      case 'topdown':
        return new TopDownRenderer();
      case 'voxel':
        return new VoxelWebGLRenderer();
      case 'webgl':
        return new ThreeJSRenderer();
      default:
        throw new Error(`Unknown renderer type: ${type}`);
    }
  }

  public static getAvailableTypes(): RendererType[] {
    return ['topdown', 'voxel', 'webgl'];
  }

  public static getDisplayName(type: RendererType): string {
    switch (type) {
      case 'topdown':
        return 'Top-Down 2D';
      case 'voxel':
        return 'Voxel Isometric';
      case 'webgl':
        return 'WebGL 3D';
      default:
        return type;
    }
  }
}
